import { Box, Grid } from "@mui/material";
import React from "react";
import "./ImageDownload.css";
import { useSelector } from "react-redux";
import Logo from "../../../images/logo-white.png";

function ImageDownload({ images, name, age, job }) {
  const { productClass, answers } = useSelector((state) => state.fPage);
  return (
    <Box sx={{ width: "100%" }}>
      <Box className="Dlmain-card">
        <Box className="header-container">
          <h1 className="header-text">
            Avatar Making Matched to Your Financial Goal and Plan
          </h1>
        </Box>
        <Box className="main-container">
          <Grid container>
            <Grid item xs={4}>
              <Box className="img-container">
                <div style={{ position: "relative", width: "80%" }}>
                  {images.map((src, index) => (
                    <img
                      key={index}
                      src={src}
                      style={{
                        width: "100%",
                        objectFit: "contain",
                        position: "absolute",
                        zIndex: index + 1,
                      }}
                      alt="IMG"
                    />
                  ))}
                </div>
              </Box>
            </Grid>
            <Grid
              item
              xs={8}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box className="bubble-container2">
                <Box className="bubble-text2">
                  {productClass === "savings" && (
                    <>
                      Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                      isang {job}. Ang pangarap ko para sa aking buhay pinansyal
                      ay {answers.mainQuestion}.
                      <br />
                      <br />
                      Upang makamit ko ang aking financial goals, ang produkto o
                      serbisyo na makakatulong sa akin ay savings.
                      <br />
                      <br />
                      Ang kabuuang halaga na gusto kong pag-ipunan ay{" "}
                      {answers.savingsQ1} pesos.
                      <br />
                      <br />
                      Ang kaya ko namang maipon kada buwan ay halagang{" "}
                      {answers.savingsQ2} pesos.
                    </>
                  )}
                  {productClass === "loan" && (
                    <>
                      Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                      isang {job}. Ang pangarap ko para sa aking buhay pinansyal
                      ay {answers.mainQuestion}.
                      <br />
                      <br />
                      Upang makamit ko ang aking financial goals, ang produkto o
                      serbisyo na makakatulong sa akin ay loan.
                      <br />
                      <br />
                      Nais kong kumuha ng loan para sa {answers.loanQ1}.
                      <br />
                      <br />
                      Gusto kong makakuha ng loan na nagkakahalaga ng{" "}
                      {answers.loanQ2} pesos.
                      <br />
                      <br />
                      Sa aking palagay ay mababayaran ko ito sa loob ng{" "}
                      {answers.loanQ3}.
                    </>
                  )}
                  {productClass === "insurance" && (
                    <>
                      Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                      isang {job}. Ang pangarap ko para sa aking buhay pinansyal
                      ay {answers.mainQuestion}.
                      <br />
                      <br />
                      Upang makamit ko ang aking financial goals, ang produkto o
                      serbisyo na makakatulong sa akin ay insurance.
                      <br />
                      <br />
                      {answers.insuranceQ1} ang klase ng insurance na nais kong
                      makuha.
                      <br />
                      <br />
                      Sa aking palagay ay kaya kong makapagbigay ng premium para
                      sa insurance sa halagang {answers.insuranceQ2} pesos.
                    </>
                  )}
                  {productClass === "others" && (
                    <>
                      Kumusta? Ako si {name}, edad {age}, na nagtatrabaho bilang
                      isang {job}. Ang pangarap ko para sa aking buhay pinansyal
                      ay {answers.mainQuestion}.
                      <br />
                      <br />
                      Upang makamit ko ang aking financial goals, ang produkto o
                      serbisyo na makakatulong sa akin ay {answers.otherQ1}.
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className="footer-container">
                <Box sx={{ width: "7%", marginRight: "2rem" }}>
                  <img
                    src={Logo}
                    alt="logo"
                    style={{
                      width: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
                |
                <Box sx={{ marginLeft: "2rem" }}>
                  <p>
                    Avatar Making Exercise from Aral Plus Quick Learning Tools
                  </p>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}

export default ImageDownload;
